import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import { CartProvider } from "./context/CartContext";
import { SiteImagesProvider } from "./context/SiteImagesContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SiteImagesProvider>
          <CartProvider>
            <SmoothScroll>
              <Navbar />
              <CartDrawer />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
              <Footer />
            </SmoothScroll>
            <Toaster
              position="bottom-center"
              toastOptions={{
                style: {
                  background: "#2D3732",
                  color: "#fff",
                  border: "none",
                  borderRadius: "9999px",
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </CartProvider>
        </SiteImagesProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
